import Vue from "vue";
import Vuex from "vuex";

import { Snackbar } from "buefy/dist/components/snackbar";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentUser: null
  },
  mutations: {
    setCurrentUser(state, payload) {
      state.currentUser = payload;
    },
    setError(state, payload) {
      Snackbar.open({
        message: payload,
        type: "is-danger"
      });
    }
  },
  actions: {}
});
